'use client';

import React from 'react';
import './LawTopMenu.scss';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SettingConfig from '@module/config/setting';
import getUserAgentInfo from '@module/utils/user-agent/getUserAgentInfo';
import { useRouter } from 'next/navigation';

function FullScreenMenu({ onClose }: { onClose: () => void }) {
  const crollintoviewHandler = (target: string) => {
    const dom = window.document.getElementById(target);
    onClose();
    setTimeout(() => {
      dom?.scrollIntoView({ behavior: 'smooth' });
    }, 400);
  };

  return (
    <div className='fixed top-0 left-0 z-50 h-screen w-screen bg-white text-center text-[17px]'>
      <div className='relative'>
        <button onClick={onClose} className='absolute top-4 right-4 p-2 text-2xl' aria-label='Close menu'>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className='pt-16'>
          <ul className='mt-4'>
            <li onClick={() => crollintoviewHandler('reservation')} className='border-gray-300 border-t border-b'>
              <a href='#' className='block py-4 '>
                예약접수
              </a>
            </li>
            <li onClick={() => crollintoviewHandler('reservation')} className=' border-gray-300 border-b'>
              <a href='#' className='block py-4 '>
                캘린더
              </a>
            </li>
            <li onClick={() => crollintoviewHandler('law-location')} className=' border-gray-300 border-b'>
              <a href='#' className='block py-4 '>
                오시는길
              </a>
            </li>
          </ul>
        </div>

        <a
          onClick={() => crollintoviewHandler('consult')}
          className='link_call fixed bottom-0 left-0 w-full bg-[#FFC601] py-4 text-center font-bold text-lg text-white'
        >
          상담신청
        </a>
      </div>
    </div>
  );
}

function LawTopMenu() {
  const router = useRouter();

  const [isFullScreenMenu, setIsFullScreenMenu] = React.useState(false);

  const scrollHandler = (target: string) => {
    const dom = window.document.getElementById(target);
    dom?.scrollIntoView({ behavior: 'smooth' });
  };

  const logoClickHandler = () => {
    const { isMobile } = getUserAgentInfo();
    if (isMobile) {
      window.location.href = 'https://m.pandalive.co.kr/';
    } else {
      router.push('/');
    }
  };

  return (
    <header className='law-top-menu'>
      <nav className='box'>
        <h2 onClick={logoClickHandler} className=''>
          <img
            alt='logo'
            src={`${SettingConfig.S3_BUCKET_URL}/img/law/law_logo.png`}
            className='w-[84px] xs:w-[140px]'
          />
        </h2>
        <ul className='menu'>
          <li onClick={() => scrollHandler('reservation')}>예약접수</li>
          <li onClick={() => scrollHandler('reservation')}>캘린더</li>
          <li onClick={() => scrollHandler('law-location')}>오시는길</li>
        </ul>
        <div onClick={() => scrollHandler('consult')} className='right-menu'>
          상담문의
        </div>
        <button className='block xs:hidden' onClick={() => setIsFullScreenMenu(!isFullScreenMenu)}>
          <FontAwesomeIcon icon={faBars} />
        </button>
      </nav>
      {isFullScreenMenu && <FullScreenMenu onClose={() => setIsFullScreenMenu(false)} />}
    </header>
  );
}

export default LawTopMenu;
